module.exports = __webpack_public_path__ + "img/cloud-remove.5f15619b.svg";